import {
  GET_HRM_SETTINGS_USER_MANUAL,
  UPDATE_HRM_SETTINGS_USER_MANUAL,
  DELETE_HRM_SETTINGS_USER_MANUAL,
} from "@actions/HRM/settings/userManual/types";

import {
  UserManualState,
  UserManualStateAction,
} from "@reducers/types/HRM/settings/user-manual-state";

export const initialState: UserManualState = {
  isGetLoading: false,
  isGetSingleLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  getSingleError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  getSingleSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
  getSingleData: null,
};

const userManualReducer = (
  state: UserManualState = initialState,
  action: UserManualStateAction,
): UserManualState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_HRM_SETTINGS_USER_MANUAL.LOADING:
      return {
        ...state,
        isGetLoading: payload,
        getError: null,
        getData: null,
        createSuccess: false,
        createError: null,
        updateSuccess: false,
        updateError: null,
      };

    case GET_HRM_SETTINGS_USER_MANUAL.ERROR:
      return {
        ...state,
        isGetLoading: false,
        getError: payload,
        getData: null,
      };

    case GET_HRM_SETTINGS_USER_MANUAL.SUCCESS:
      return {
        ...state,
        isGetLoading: false,
        getError: null,
        getData: payload,
      };

    // update
    case UPDATE_HRM_SETTINGS_USER_MANUAL.LOADING:
      return {
        ...state,
        isUpdateLoading: payload,
        updateError: null,
        updateSuccess: false,
      };

    case UPDATE_HRM_SETTINGS_USER_MANUAL.ERROR:
      return {
        ...state,
        isUpdateLoading: false,
        updateError: payload,
        updateSuccess: false,
      };

    case UPDATE_HRM_SETTINGS_USER_MANUAL.SUCCESS:
      return {
        ...state,
        isUpdateLoading: false,
        updateError: null,
        updateSuccess: true,
      };

    case DELETE_HRM_SETTINGS_USER_MANUAL.LOADING:
      return {
        ...state,
        isUpdateLoading: payload,
        deleteError: null,
        deleteSuccess: false,
      };

    case DELETE_HRM_SETTINGS_USER_MANUAL.ERROR:
      return {
        ...state,
        isUpdateLoading: false,
        deleteError: payload,
        deleteSuccess: false,
      };

    case DELETE_HRM_SETTINGS_USER_MANUAL.SUCCESS:
      // const { payload: resData } = action as any;

      // const updatedData =
      //   state && state.data
      //     ? state.data.filter((item: any) => item.id !== resData?.data)
      //     : [];

      return {
        ...state,
        isUpdateLoading: false,
        deleteError: null,
        deleteSuccess: true,
      };

    default:
      return state;
  }
};

export default userManualReducer;
